import PropTypes from 'prop-types'
import React, { useState } from 'react'
import Swiper from 'react-id-swiper'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import Loader from 'components/loader'
import { SEE_ALL, TRAILING } from 'components/recently-view/const'
import { BUTTON_TYPES } from 'constants/button'
import QuickAddToBagModal from 'components/shared/quick-add-to-bag-modal/QuickAddToBagModal'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { bindActionCreators } from 'redux'
import ProductItem from '../product-item'
import SeeAllCard from '../product-item/see-all-card'
import styles from './style.scss'
import productsVouchersDuck from '../product-list/products-vouchers/duck'
import useProductsVouchers from '../product-list/products-vouchers/useProductsVouchers'

const ProductListSlider = (props) => {
  const [isDeleteWishlistProductTimeOut, setIsDeleteWishlistProductTimeOut] =
    useState(false)
  const [undoClicked, setUndoClicked] = useState(false)
  const { list, productsVouchers, updateProductsVouchersList } = props

  useProductsVouchers({
    products: list,
    productsVouchers,
    updateProductsVouchersList,
  })

  const renderProductItem = (product, idx) => {
    const {
      displayBadges,
      displayPrice,
      displayDescription,
      displaySwatches,
      displayWishlistIcon,
      displayQuickAddToCart,
      displayFlashSaleTitle,
      displayManufacturerName,
      refId,
      refType,
      seeAllCardHeight,
      seeAllCardWidth,
      setFirstProductRef,
      subPosition,
    } = props

    if (product.id_product === TRAILING) {
      return <div className="trailing-space" />
    }

    if (product.id_product === SEE_ALL) {
      return (
        <SeeAllCard
          key={product.id_product}
          refType={refType}
          seeAllCardHeight={seeAllCardHeight}
          seeAllCardWidth={seeAllCardWidth}
        />
      )
    }

    const productVoucher = productsVouchers.find(
      (voucher) => voucher.id_product === product.id_product,
    )

    return (
      <div
        className="product-item-slider-wrapper"
        key={product.product_id || product.id_product || product.id_product_2}
      >
        <ProductItem
          className="product-item-slide"
          displayBadges={displayBadges}
          displayDescription={displayDescription}
          displayPrice={displayPrice}
          displaySwatches={displaySwatches}
          displayWishlistIcon={displayWishlistIcon}
          displayManufacturerName={displayManufacturerName}
          displayFlashSaleTitle={displayFlashSaleTitle}
          idx={idx + 1}
          refId={refId}
          refType={refType}
          setFirstProductRef={idx === 0 ? setFirstProductRef : undefined}
          subPosition={subPosition}
          product={product}
          promptLocation="wishlist_appfeed"
          is_flash_sale={
            product?.is_flash_sale || product?.prices?.is_flash_sale
          }
          flash_sale_seconds_left={
            product?.flash_sale_seconds_left ||
            product?.prices?.flash_sale_seconds_left
          }
          undoClicked={undoClicked}
          setUndoClicked={setUndoClicked}
          setIsSnackBarOpen={() => {}}
          isDeleteWishlistProductTimeOut={isDeleteWishlistProductTimeOut}
          setIsDeleteWishlistProductTimeOut={setIsDeleteWishlistProductTimeOut}
          productVoucher={productVoucher}
          {...product}
        />
        {displayQuickAddToCart && (
          <QuickAddToBagModal
            refId={refId}
            refType={refType}
            id_product={product.id_product}
            product_name={product?.name}
            sizes={product?.sizes}
            id_site_category={product?.id_category_default}
          />
        )}
      </div>
    )
  }

  const renderArrow = (arrowClass, buttonClass, customArrowStyle, src) => (
    <button
      className={buttonClass}
      style={customArrowStyle}
      type={BUTTON_TYPES.containedLight}
    >
      <Icon className={arrowClass} src={src} size={ICON_SIZE.small} />
    </button>
  )

  const renderProductSlider = () => {
    const {
      slidesPerView,
      customArrowProps,
      customSliderOptions,
      displayBullets,
      isPhone,
    } = props
    const { class: customArrowClass, style: customArrowStyle } =
      customArrowProps
    const sliderOptions = {
      spaceBetween: 10,
      slidesPerView,
      roundLengths: true,
      shouldSwiperUpdate: true,
      preventClicks: true,
      preventClicksPropagation: true,
      threshold: 25,
      ...(displayBullets && {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
      }),
      ...(!isPhone && {
        navigation: {
          nextEl: `.${customArrowClass.rightArrow}`,
          prevEl: `.${customArrowClass.leftArrow}`,
        },
        renderPrevButton: () =>
          renderArrow(
            'left-arrow',
            customArrowClass.leftArrow,
            customArrowStyle,
            ICONS.arrowHeadLeft,
          ),
        renderNextButton: () =>
          renderArrow(
            'right-arrow',
            customArrowClass.rightArrow,
            customArrowStyle,
            ICONS.arrowHeadRight,
          ),
      }),
      ...customSliderOptions,
    }

    return <Swiper {...sliderOptions}>{list.map(renderProductItem)}</Swiper>
  }

  const renderLoading = () => (
    <div>
      <style jsx>{styles}</style>
      <div className="slider-loader">
        <Loader />
      </div>
    </div>
  )

  if (!list?.length) {
    return renderLoading()
  }

  return renderProductSlider()
}

ProductListSlider.defaultProps = {
  customArrowProps: {},
  customSliderOptions: {},
  displayBadges: true,
  displayBullets: true,
  displayDescription: false,
  displayPrice: true,
  displaySwatches: false,
  displayWishlistIcon: false,
  displayQuickAddToCart: false,
  displayFlashSaleTitle: true,
  displayManufacturerName: true,
  isPhone: undefined,
  list: [],
  refId: '',
  refType: '',
  subPosition: '',
  slidesPerView: 2.5,
  firstProductRef: undefined,
  setFirstProductRef: undefined,
  seeAllCardHeight: 100,
  seeAllCardWidth: 100,
  productsVouchers: [],
  updateProductsVouchersList: null,
}

ProductListSlider.propTypes = {
  customArrowProps: PropTypes.shape({
    class: PropTypes.shape({
      leftArrow: PropTypes.string,
      rightArrow: PropTypes.string,
    }),
    style: PropTypes.shape({}),
  }),
  slidesPerView: PropTypes.number,
  customSliderOptions: PropTypes.shape({}),
  displayBadges: PropTypes.bool,
  displayBullets: PropTypes.bool,
  displayDescription: PropTypes.bool,
  displayPrice: PropTypes.bool,
  displaySwatches: PropTypes.bool,
  displayWishlistIcon: PropTypes.bool,
  displayQuickAddToCart: PropTypes.bool,
  displayFlashSaleTitle: PropTypes.bool,
  displayManufacturerName: PropTypes.bool,
  firstProductRef: PropTypes.func,
  isPhone: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.shape({})),
  refId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  refType: PropTypes.string,
  seeAllCardHeight: PropTypes.number,
  seeAllCardWidth: PropTypes.number,
  setFirstProductRef: PropTypes.func,
  subPosition: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  productsVouchers: PropTypes.arrayOf(PropTypes.shape({})),
  updateProductsVouchersList: PropTypes.func,
}

export default compose(
  connect(
    (state) => ({
      view: state.visibility.view,
      isPhone: state.device.isPhone,
      internationalization: state.internationalization,
      productsVouchers: state.productsVouchers.productsVouchersList,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          updateProductsVouchersList:
            productsVouchersDuck.creators.updateProductsVouchersList,
        },
        dispatch,
      ),
  ),
)(ProductListSlider)
